import { render, staticRenderFns } from "./ShowVarietiesModal.vue?vue&type=template&id=0a896471&scoped=true&"
import script from "./ShowVarietiesModal.vue?vue&type=script&lang=js&"
export * from "./ShowVarietiesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a896471",
  null
  
)

export default component.exports